import React, { useState } from "react";
import {
  Box,
  IconButton,
  TextField,
  Typography,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputAdornment,
  Chip,
  Tooltip,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import FilterListIcon from "@mui/icons-material/FilterList";
import TableChartIcon from "@mui/icons-material/TableChart";
import DeleteIcon from "@mui/icons-material/Delete";
import ClearIcon from "@mui/icons-material/Clear";
import ViewModeSwitcher from "./ViewModeSwitcher";
import AddButton from "./AddButton";
import RestoreIcon from "@mui/icons-material/Restore";

function Toolbar({
  currentPage,
  // businessTypeKey, // Убираем - больше не нужен
  onAddClick,
  onViewChange,
  onRefresh,
  onExport,
  selectedItems = [],
  onDeleteSelected,
  onRestoreSelected, // Добавлено: обработчик восстановления выбранных
  onOpenColumnsModal, // Добавлено: обработчик для открытия модального окна колонок
  onOpenFiltersModal,
  children,
  totalRecords = 0,
  recordsLabel = "записей", // Добавлено: метка для записей
  searchQuery = "",
  onSearchChange,
  onSearchSubmit,
  onSearchClear, // Добавлено: очистка поиска
  customButtons = [], // Добавлено: кастомные кнопки
  pageSize = 50, // Добавлено: текущий размер страницы
  onPageSizeChange, // Добавлено: обработчик изменения размера страницы
}) {
  const [viewMode, setViewMode] = useState("list");

  // Обработчик переключения видов
  const handleViewChange = (mode) => {
    console.log(`Switching to view mode: ${mode}`);
    setViewMode(mode);
    if (onViewChange) onViewChange(mode);
  };

  return (
    <Box className="erp-list-toolbar"
      sx={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "#fff",
        padding: "16px 20px",
        borderRadius: "16px",
        marginBottom: "16px",
        boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
      }}
    >
      <div className="erp-page-heading"><h1>{({assets:'Активы', rental_assets:'Активы', clients:'Клиенты', rental_deals:'Сделки аренды', deals:'Продажи', expenses:'Расходы', staff:'Сотрудники', applications:'Заявки', procurement:'Закупки'})[currentPage] || 'Список записей'}</h1><p>Поиск, управление и история вашего проката</p></div>
      {/* Кнопка "Добавить" */}
      <AddButton
        // businessTypeKey={businessTypeKey} // Убираем - больше не нужен
        moduleKey={currentPage} // Передаем текущую страницу как ключ модуля
        onAddClick={onAddClick} // Передаем обработчик клика
      />

      {/* Фильтры и действия */}
      <Box className="erp-list-actions"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {/* Левая сторона: ViewModeSwitcher и счетчик сотрудников */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <ViewModeSwitcher
            viewMode={viewMode}
            onViewChange={handleViewChange}
          />

          <Typography variant="subtitle1">
            Всего:{" "}
            <Chip
              label={`${totalRecords} ${recordsLabel}`}
              size="small"
              sx={{
                fontWeight: 700,
                fontSize: "0.8rem",
                backgroundColor: "#eef2ff",
                color: "#0878ff",
                borderRadius: "8px",
              }}
            />
          </Typography>

          {/* Выбор количества записей на странице */}
          {onPageSizeChange && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Typography variant="body2" color="text.secondary">
                Показывать:
              </Typography>
              <FormControl size="small" sx={{ minWidth: 80 }}>
                <Select
                  value={pageSize}
                  onChange={(e) => onPageSizeChange(e.target.value)}
                  sx={{ height: 32 }}
                >
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                </Select>
              </FormControl>
            </Box>
          )}
        </Box>

        <Box sx={{ display: "flex", alignItems: "center" }}>
          {selectedItems.length > 0 && (
            <Tooltip title="Удалить выбранные">
              <IconButton
                onClick={onDeleteSelected}
                color="error"
                sx={{ borderRadius: "10px" }}
              >
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          )}

          <Tooltip title="Обновить">
            <IconButton
              onClick={onRefresh}
              sx={{
                borderRadius: "10px",
                "&:hover": { backgroundColor: "#f0f4ff" },
              }}
            >
              <RefreshIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Экспорт">
            <IconButton
              onClick={onExport}
              sx={{
                borderRadius: "10px",
                "&:hover": { backgroundColor: "#f0f4ff" },
              }}
            >
              <FileDownloadIcon />
            </IconButton>
          </Tooltip>

          {/* Кастомные кнопки */}
          {customButtons.map((button, index) => (
            <Box key={index} sx={{ ml: 0.5 }}>
              <Button
                variant="outlined"
                startIcon={button.icon}
                onClick={button.onClick}
                size="small"
                sx={{
                  borderRadius: "10px",
                  textTransform: "none",
                  fontWeight: 600,
                }}
              >
                {button.label}
              </Button>
            </Box>
          ))}

          <Tooltip title="Настройка колонок">
            <IconButton
              onClick={() => {
                onOpenColumnsModal();
              }}
              sx={{
                borderRadius: "10px",
                "&:hover": { backgroundColor: "#f0f4ff" },
              }}
            >
              <TableChartIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title="Фильтры">
            <IconButton
              onClick={() => {
                onOpenFiltersModal();
              }}
              sx={{
                borderRadius: "10px",
                "&:hover": { backgroundColor: "#f0f4ff" },
              }}
            >
              <FilterListIcon />
            </IconButton>
          </Tooltip>
          <form onSubmit={onSearchSubmit}>
            <TextField
              placeholder="Поиск"
              variant="outlined"
              size="small"
              value={searchQuery}
              onChange={onSearchChange}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "10px",
                  backgroundColor: "#f9fafc",
                },
              }}
              InputProps={{
                endAdornment: searchQuery && (
                  <InputAdornment position="end">
                    <IconButton
                      size="small"
                      onClick={() => {
                        if (onSearchClear) {
                          onSearchClear();
                        } else if (onSearchChange) {
                          onSearchChange({ target: { value: "" } });
                        }
                      }}
                      edge="end"
                      sx={{ p: 0.5 }}
                    >
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </form>
        </Box>
      </Box>

      {/* Контент */}
      <Box sx={{ marginTop: "20px" }}>{children}</Box>
    </Box>
  );
}

export default Toolbar;
